import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5';
import { versionsText } from './config';

axios.defaults.timeout = 50000; // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 配置请求头
// axios.defaults.baseURL = '';

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  // 在发送请求之前做某件事
  if (config.url.indexOf('/mobile/v1') > 0 || config.url.indexOf('/mobile/h5') > 0) {
    if (config.url.indexOf('/mobile/v1') > 0) {
      config.headers.post['wxXcxToken'] = config.data.wxXcxToken
    }
    config.headers.post['Content-Type'] = 'application/json'
  } else {
    if (config.url.indexOf(versionsText) < 0) {
      if (config.method === 'post' && config.headers.urlType != 'noStringify') {
        config.data = qs.stringify(config.data);
      }
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  if (res.headers['content-type'].includes('application/vnd.ms-excel')) {
    return Promise.resolve(res);
  } else if (!res.data.success) {
    // 对响应数据做些事
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  return Promise.reject(error);
})

// 返回一个Promise(发送post请求)
export function uploadFile (url, param) {
  return new Promise((resolve, reject) => {
    axios.post(url,
      param,
      {
        headers: {
          'Content-Type': 'multipart/form-data;',
          urlType: 'noStringify'
        }
      }
    ).then(response => {
      if (response.data.code == 0) {
        resolve(response.data.data)
      } else {
        invokeError(response, url)
      }
    }, err => {
      reject(err)
    }).catch((error) => {
      reject(error)
    })
  })
}
// 返回一个Promise(发送post请求)
export function fetchPost (url, param, noHeader) {
  var content = JSON.stringify(param)
  if (!content) {
    content = ''
  }
  var headers = {}
  if (!noHeader) {
    if (url.indexOf('/mobile/v1') > 0) {
      headers = {
        wxXcxToken: param.wxXcxToken,
        'Content-Type': 'application/json'
      }
    } else {
      headers = genHeaders(content)
    }
  }
  let axiosParam = {}
  if (url.indexOf(versionsText) > 0 || url.indexOf('/mobile/v1') > 0 || url.indexOf('/mobile/h5') > 0) {
    axiosParam = param
  } else {
    axiosParam = {
      content: content
    }
  }
  return new Promise((resolve, reject) => {
    axios.post(url,
      axiosParam
      , {
        headers: headers
      }).then(response => {
        if (response.headers['content-type'].includes('application/vnd.ms-excel')) {
          resolve(response);
        } else if (response.data.code == 0) {
          resolve(response.data.data);
        } else if (response.data.code == 10) {
          resolve(response.data);
        } else if (response.data.code == 9) { // 未登录
          invokeError(response, url);
        } else {
          // console.log(response.data.message);
          invokeError(response, url);
        }
      }, err => {
        reject(err);
      }).catch((error) => {
        reject(error)
      })
  })
}
// 返回一个Promise(发送get请求)
export function fetchGet (url, param, pConfig, noHeader) {
  let isNewApi = false;
  if (url.indexOf(versionsText) > 0) {
    isNewApi = true
  }
  var content = JSON.stringify(param);
  if (!isNewApi) {
    if (!content) {
      content = "";
    }
    if (content) {
      url = url + '?content=' + encodeURIComponent(content);
    }
  }

  let tObj
  var headers = {}
  if (!noHeader) {
    headers = genHeaders(content)
  }

  if (pConfig && pConfig.type === 'default') {
    tObj = { headers: headers }
  } else {
    if (noHeader) {
      tObj = { params: param }
    } else {
      tObj = { headers: headers, params: param }
    }
  }
  return new Promise((resolve, reject) => {
    axios.get(url, tObj).then(response => {
        if (response.data.code == 0 || response.data.code == 2) {
          resolve(response.data.data);
        } else if (response.data.code == 9) { // 未登录
          // context.$router.push('/login');
        } else {
          // console.log(response.data.message);
          invokeError(response, url);
        }
      }, err => {
        reject(err)
      }).catch((error) => {
        reject(error)
      })
  })
}


function genHeaders(content) {
  var pcToken = localStorage.getItem("pcToken");
  var userId = localStorage.getItem("userId");
  var pre = pcToken.substring(16, 21) + content;
  if (userId.length < 32) {
    pre += userId;
  } else {
    pre += userId.substring(16, 21);
  }
  var sign = md5(pre);
  return {
    pcToken: pcToken,
    sign: sign
  };
}

function invokeError(response, url) {
  if (response && response.data) {
    if (response.data.message) {
      gg.router.app.$notify(response.data.message);
    } else {
      gg.router.app.$notify(tMsg);
    }
  } else {
    gg.router.app.$notify("服务器异常");
  }

}
export default {
  fetchPost,
  uploadFile,
  fetchGet
}



// WEBPACK FOOTER //
// ./src/common/https.js